var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconAdd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 6.25C35.3125 6.25 43.75 14.6875 43.75 25C43.75 35.3125 35.3125 43.75 25 43.75C14.6875 43.75 6.25 35.3125 6.25 25C6.25 14.6875 14.6875 6.25 25 6.25ZM25 3.125C12.9688 3.125 3.125 12.9688 3.125 25C3.125 37.0312 12.9688 46.875 25 46.875C37.0312 46.875 46.875 37.0312 46.875 25C46.875 12.9688 37.0312 3.125 25 3.125Z",
    fill: "#00CCBC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 23.4375H26.5625V12.5H23.4375V23.4375H12.5V26.5625H23.4375V37.5H26.5625V26.5625H37.5V23.4375Z",
    fill: "#00CCBC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconAdd);
export default __webpack_public_path__ + "static/media/icon-add.9990ac7d8b937e6b6872e02ab15b5db3.svg";
export { ForwardRef as ReactComponent };